export const LOAD_USER_STORE_LOCATION_INFO = 'LOAD_USER_STORE_LOCATION_INFO';
export const UPDATE_USER_STORE_LOCATION_INFO = 'UPDATE_USER_STORE_LOCATION_INFO';
export const SET_USER_STORE_LOCATION_INFO = 'SET_USER_STORE_LOCATION_INFO';
export const LOAD_USER_STORE_LOCATION_INFO_ERROR = 'LOAD_USER_STORE_LOCATION_INFO_ERROR';
export const UPDATE_CART_STORE = 'UPDATE_CART_STORE';
